import { withExerciseMultipleChoiceAdminContext } from '@doltech/ui/lib/figma/BlogEditor/plugins/ExerciseMultipleChoice/components/AdminContext';
import { BlogSocialButtonPreview } from '@doltech/ui/lib/figma/Layout/Landing/SocialButton/BlogSocialButton';
import { calculateTableOfContent } from '@doltech/utils/lib/url';
import { noop } from 'lodash';
import * as React from 'react';
import styled from 'styled-components';
import { GrammarLandingBlogEditorLayout } from './GrammarLandingBlogEditorLayout';
import { scrollBarStylesGeneral } from '@doltech/utils/lib/css-style';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { getSlateEditorValue } from '@doltech/utils/lib/editor';
import { getTableOfContentForView } from '@doltech/modules/lib/admin-blog-management/book-review/Steps/BlogEditor/BlogPreview';
import { GrammarBlogEditorReadOnlyV2 } from '../core-blog-editor/core/GrammarBlogEditorReadOnlyV2';

const Wrapper = styled.div`
  #blog-cover {
    img {
      border-radius: 16px;
    }
  }

  .blog-editor-body {
    h2,
    h3 {
      font-weight: 600;
    }

    padding-bottom: 0;
  }

  h1 {
    margin: 0;
  }

  h2,
  h3 {
    font-weight: 600;
  }

  .icon-clap {
    svg {
      transform: scaleX(-1);
      margin-top: 5px;
    }
  }

  table {
    display: block;
    overflow-x: auto;
    ${scrollBarStylesGeneral(colorsV2.gray40)};

    tbody {
      display: block;
      width: 100%;
    }

    td {
      min-width: 200px;
    }
  }

  .inner-gap-fill,
  .do-test-exercise-short-answer-input,
  .blank-option-input,
  .do-test-exercise-gap-fill-hints,
  .paragraph-toggle-element,
  .do-test-exercise-quiz-question {
    span {
      font-size: 16px !important;
      line-height: 1.2;
    }
  }
`;

/* stylelint-disable no-descending-specificity */

export const GrammarDetailLessonBase = withExerciseMultipleChoiceAdminContext(
  ({
    onBackWhenInComplete = noop,
    detailInfo,
    data,
    dol,
    renderBottomAuthor,
    renderTopAuthor,
    progressData,
    renderUserInfo,
    onCheckAnswer,
    onNeedToSignIn,
  }) => {
    const { tableOfContentHidden, tableOfContent, tocTitle, body, isTocShown } = data || {};

    const tableOfContentForView = React.useMemo(() => {
      return getTableOfContentForView({ tableOfContent, tableOfContentHidden });
    }, [tableOfContent, tableOfContentHidden]);

    return (
      <Wrapper>
        <GrammarLandingBlogEditorLayout
          initHeader={{
            blogTitle: data?.blogTitle,
            blogDescription: data?.blogDescription,
            image: dol?.fileInfo,
            caption: dol?.fileInfo?.caption,
            alt: dol?.fileInfo?.alt,
            imgTitle: dol?.fileInfo?.title,
          }}
          useSideBar={false}
          seoData={undefined}
          title={tocTitle}
          socials={BlogSocialButtonPreview}
          tableOfContentEditor={isTocShown === false ? undefined : tableOfContentForView}
          detailInfo={detailInfo}
          renderTopAuthor={renderTopAuthor}
          renderBottomAuthor={renderBottomAuthor}
          renderUserInfo={renderUserInfo}
        >
          <div className="responsive-blog-section" id="blog-preview-content">
            <GrammarBlogEditorReadOnlyV2
              onMounted={() => calculateTableOfContent(tableOfContentForView)}
              initialValue={getSlateEditorValue(body)}
              onBackWhenInComplete={onBackWhenInComplete}
              onCheckAnswer={onCheckAnswer}
              onNeedToSignIn={onNeedToSignIn}
              progressData={progressData}
              isReadOnly
            />
          </div>
        </GrammarLandingBlogEditorLayout>
      </Wrapper>
    );
  }
);
